import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getRouteById = (id) => {
    return vdkEmHappinessPortalApi.get(`/routes/${id}`);
};
const removePickupLocationFromRoute = (routeId, pickupLocationId) => {
    return vdkEmHappinessPortalApi.delete(`/routes/${routeId}/pickup-locations/${pickupLocationId}`);
};
const getRoutesByEventId = (eventId, query) => {
    return vdkEmHappinessPortalApi.post(`/events/${eventId}/routes/search`, query);
};
const createRoute = (request) => {
    return vdkEmHappinessPortalApi.post(`/events/${request.eventId}/routes`, request);
};
const updateRoute = (request) => {
    return vdkEmHappinessPortalApi.put(`/routes/${request.id}`, request);
};
const deleteRoute = (id) => {
    return vdkEmHappinessPortalApi.delete(`/routes/${id}`);
};
const addPickupLocationToRoute = (request) => {
    return vdkEmHappinessPortalApi.post(`/routes/${request.routeId}/pickup-locations`, request);
};
const addVehicleToRoute = (request) => {
    return vdkEmHappinessPortalApi.post(`/routes/${request.routeId}/vehicles`, request);
};
const removeVehicleFromRoute = (routeId, vehicleId) => {
    return vdkEmHappinessPortalApi.delete(`/routes/${routeId}/vehicles/${vehicleId}`);
};
const reorderRouteStops = (routeId, stops) => {
    return vdkEmHappinessPortalApi.put(`/routes/${routeId}/pickup-locations/reorder`, {
        stops
    });
};
const transportRouteAPI = {
    getRouteById,
    getRoutesByEventId,
    createRoute,
    updateRoute,
    deleteRoute,
    addPickupLocationToRoute,
    removePickupLocationFromRoute,
    addVehicleToRoute,
    removeVehicleFromRoute,
    reorderRouteStops
};
export default transportRouteAPI;
